<template>
	<router-view v-if="isRouterAlive" />
</template>

<script>
	export default {
		name: 'App',
		provide() { //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true //控制视图是否显示的变量
			}
		},
		mounted() {
			window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
			window.addEventListener('unload', e => this.unloadHandler(e))
		},
		unmounted() {
			window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
			window.removeEventListener('unload', e => this.unloadHandler(e))
		},
		methods: {
			beforeunloadHandler() {
				this._beforeUnload_time = new Date().getTime();
			},
			unloadHandler(e) {
				this._gap_time = new Date().getTime() - this._beforeUnload_time;
				//判断是窗口关闭还是刷新
				console.log(this._gap_time)
				if (this._gap_time <= 5) {
					//如果是登录状态，关闭窗口前，移除用户
					console.log(this.$route)
					if(this.$route.name != 'yulan'){
						localStorage.clear()
					}
				}
			},
			reload() {
				this.isRouterAlive = false; //先关闭，
				this.$nextTick(function() {
					this.isRouterAlive = true; //再打开
				})
			}
		},
	};
</script>

<style>
	@import "./assets/css/main.css";
	@import "./assets/css/color-dark.css";
</style>
